import { render, staticRenderFns } from "./company-result.vue?vue&type=template&id=063b04f8&"
import script from "./company-result.vue?vue&type=script&lang=js&"
export * from "./company-result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports